import type {
  SectionItemDM,
  ThreeUpView,
} from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/MultiSectionView.types';
import type { ViewData } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/common/multisection.data';
import { layoutThreeUp } from '@Components/BigBrowse/Views/DetailViews/MultiSectionView/threeUp/helpers/ThreeUpLayout';

export async function addThreeUp(
  viewData: ViewData,
  section: SectionItemDM
): Promise<ViewData> {
  const threeUpView = getThreeUpView(viewData, section);
  // legacy code that updates the layoutTable in mutable way
  await layoutThreeUp({
    section: threeUpView,
    layoutTable: viewData.layoutTable!,
  });
  return viewData;
}

function getThreeUpView(
  viewData: ViewData,
  section: SectionItemDM
): ThreeUpView {
  return {
    id: section.id,
    key: [
      'brandconcession',
      viewData.modelData.concessionId,
      'section',
      section.id,
    ].join('-'),
    type: section.template,
    dtoData: section,
    sectionId: section.id,
  };
}
